






import CurrencyFormatter from '../../currencyFormatter';

export default {
    prop: {
        currency: {
            default: "DKK",
            type: String
        }
    },
    data() {
        return {
            totalPrice: 0
        }
    },
    mounted: function() {
        
        const self = this;
        
        if(this.$slots.default[0].elm != null) {
            (<any>this.$slots.default[0].elm).addEventListener("submit",(event) => {
                event.preventDefault();
              
                //Send form to action
                fetch(event.target.getAttribute("action"), {
                    method: 'POST',
                    body: new FormData(event.target),
                }).then(function (response) {
                    if (response.ok) {
                        return response.json();
                    }
                    return Promise.reject(response);
                }).then(function (data) {                        
                    <HTMLElement>self.$el.closest('.detail-dropdown').removeAttribute('data-show');

                    //Reset form 
                    const elements = (<any>self.$slots.default[0].elm).querySelectorAll("experience-dropdown-element");
                    Array.prototype.slice.call(elements).map((element) => {
                        const vueInstance = element.getVueInstance(); //F� fat i vue instance objketet.
                        vueInstance.reset();
                    });

                    self.emitCartUpdate();

                }).catch(function (error) {
                    //TODO: Set notifications
                    console.warn(error);
                });


            });
        }

        this.$on('totalPrice', (event) => {
            //reset totalPrice                
            this.totalPrice = 0;

            //Find alle dropdown-elements
            const elements = (<any>this.$slots.default[0].elm).querySelectorAll("experience-dropdown-element");
            Array.prototype.slice.call(elements).map((element) => {
                const vueInstance = element.getVueInstance(); //F� fat i vue instance objketet.
                this.totalPrice += vueInstance.totalPrice; //l�g total prisen til this.totalprice.
            });

            //Find Knappens span tag til submit
            CurrencyFormatter(this.currency).format(this.price);
            const button = (<any>this.$slots.default[0].elm).querySelector("button[type='submit'] span");
            button.innerHTML = "(" + CurrencyFormatter(this.currency).format(this.totalPrice) + ")"; //Inds�t total prisen  
        })
    },
    methods: {
   
        emitCartUpdate() {
            //Emit update to HeaderCart
            const element = (<HTMLElement>document.getElementsByClassName("cart-container")[0]);
            if (element != null) {
                const event = new Event('updateCart');

                element.dispatchEvent(event);
            }
            
        }
    }
}
